import React from "react";
import { SectionHeading, PrayerAndRitesCard } from "../components";
import { Skeleton } from "../components/ui/skeleton";

const PrayersList = React.memo(
  ({ data, isLoading, searchQuery, onToggleFavorite }) => {
    const { title, icon, link, linkTitle, items = [], titleClass = "" } = data;

    return (
      <div>
        {/* Section Heading */}
        {title && isLoading ? (
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">
              <Skeleton className="w-6 h-8 rounded" />
              <Skeleton className="w-32 h-8 rounded" />
            </div>
            <Skeleton className="w-20 h-5 rounded" />
          </div>
        ) : (
          title && (
            <SectionHeading
              title={title}
              icon={icon}
              link={link}
              linkTitle={linkTitle}
              titleClass={titleClass}
            />
          )
        )}

        {/* Skeleton Loader (2x2 Grid) */}
        {isLoading ? (
          <div className="grid gap-4 mt-4 xl:grid-cols-2">
            {[...Array(4)].map((_, index) => (
              <Skeleton key={index} className="h-[100px] w-full rounded-lg" />
            ))}
          </div>
        ) : items.length > 0 ? (
          <div className="grid gap-4 mt-4 xl:grid-cols-2">
            {items.map((item) => (
              <PrayerAndRitesCard
                key={item.slug}
                {...item}
                isLoading={isLoading}
                onToggleFavorite={onToggleFavorite}
              />
            ))}
          </div>
        ) :  (
          // Display message when no search results are found
          <div className="py-6 text-center text-gray-500">
            {searchQuery
              ? `No prayers found for "${searchQuery}"`
              : "No prayers found"}
          </div>
        )}
      </div>
    );
  }
);

export default PrayersList;
